import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  RegisterTemplate,
  IRegisterTemplate,
} from '@core/entities/register/RegisterTemplate'
import {
  RequestTypes,
  registerTemplateKeys,
} from '@core/react-query/features/registers/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const templatesTransform = (response: IRegisterTemplate[]) =>
  response.map((template) => RegisterTemplate.new(template))

export const useGetLiveRegisterTemplates = (
  payload: RequestTypes['getRegisterTemplatesLive'],
  options?: UseQueryOptions<
    IRegisterTemplate[],
    RequestErrorType,
    RegisterTemplate[]
  >,
) => {
  return useQuery({
    select: templatesTransform,
    ...registerTemplateKeys.byOrganisationLive(payload),
    ...options,
  })
}
